/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Cargo_Supervision_DetailInputs */



/**
* | output |
* | --- |
* | "Independent attendance and supervision of loading and discharge operations. We monitor quantities, condition and handling, and record what happens, so that a..." |
*
* @param {Service_Cargo_Supervision_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_cargo_supervision_detail = /** @type {((inputs?: Service_Cargo_Supervision_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Cargo_Supervision_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对装卸作业进行独立的现场监督。我们监控货物数量、状况和操作，并如实记录，以便任何短少、货损或纠纷都能以可靠证据处理。")
	return /** @type {LocalizedString} */ ("Independent attendance and supervision of loading and discharge operations. We monitor quantities, condition and handling, and record what happens, so that any shortage, damage or dispute can be dealt with on solid evidence.")
});